import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { pageTypes } from 'config/pageTypes';

function getOgUrl(contentType, keyword) {
	switch (contentType) {
		case pageTypes.SGP:
			return `https://www.sparefoot.com/storage-unit-size-guide/${keyword}-storage-unit.html`;
		case pageTypes.PSP:
			return `https://www.sparefoot.com/${keyword}-storage.html`;
	}
}

function getOgImage(contentType, keyword) {
	switch (contentType) {
		case pageTypes.SGP:
			return `https://www.sparefoot.com/static/images/sgp/hero/${keyword}-hero.jpg`;
		case pageTypes.PSP:
			return `https://www.sparefoot.com/static/images/psp/hero/${keyword}-hero.jpg`;
	}
}
export function PSPMeta({ metadata, keyword, contentType = pageTypes.PSP }) {
	console.log(metadata?.description, 'metadata?.description')
	return (
		<Helmet>
			<title>{metadata?.title}</title>
			<meta
				name="description"
				content={metadata?.description}
			/>
			<meta
				property="og:title"
				content={metadata?.title}
			/>
			<meta
				property="og:description"
				content={metadata?.description}
			/>
			<meta
				property="og:url"
				content={`${getOgUrl(contentType, keyword)}`}
			/>
			<meta
				property="og:type"
				content="website"
			/>
			<meta
				property="og:image"
				content={`${getOgImage(contentType, keyword)}`}
			/>
			<meta
				property="og:site_name"
				content="SpareFoot"
			/>
			<meta
				name="twitter:card"
				content="summary_large_image"
			/>
			<meta
				name="twitter:site"
				content="@sparefoot"
			/>
			<meta
				name="twitter:title"
				content={metadata?.title}
			/>
			<meta
				name="twitter:description"
				content={metadata?.description}
			/>
			<meta
				name="twitter:image"
				content={`${getOgImage(contentType, keyword)}`}
			/>
		</Helmet>
	);
}

PSPMeta.propTypes = {
	metadata: PropTypes.object,
	keyword: PropTypes.string,
	contentType: PropTypes.string,
};

export default PSPMeta;
